module.exports = __webpack_public_path__ + "img/360-degree.0dcb0004.png";